/* @generated from adl module Terminal */

import * as ADL from './runtime/adl';

export interface TerminalSize {
  width: number;
  height: number;
}

export function makeTerminalSize(
  input: {
    width: number,
    height: number,
  }
): TerminalSize {
  return {
    width: input.width,
    height: input.height,
  };
}

const TerminalSize_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"width","default":{"kind":"nothing"},"name":"width","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"height","default":{"kind":"nothing"},"name":"height","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"TerminalSize","version":{"kind":"nothing"}}};

export const snTerminalSize: ADL.ScopedName = {moduleName:"Terminal", name:"TerminalSize"};

export function texprTerminalSize(): ADL.ATypeExpr<TerminalSize> {
  return {value : {typeRef : {kind: "reference", value : snTerminalSize}, parameters : []}};
}

export interface TerminalCreateParams {
  size: TerminalSize;
  path: string;
  argv: string[];
}

export function makeTerminalCreateParams(
  input: {
    size: TerminalSize,
    path: string,
    argv: string[],
  }
): TerminalCreateParams {
  return {
    size: input.size,
    path: input.path,
    argv: input.argv,
  };
}

const TerminalCreateParams_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"size","default":{"kind":"nothing"},"name":"size","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"TerminalSize"}},"parameters":[]}},{"annotations":[],"serializedName":"path","default":{"kind":"nothing"},"name":"path","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"argv","default":{"kind":"nothing"},"name":"argv","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"TerminalCreateParams","version":{"kind":"nothing"}}};

export const snTerminalCreateParams: ADL.ScopedName = {moduleName:"Terminal", name:"TerminalCreateParams"};

export function texprTerminalCreateParams(): ADL.ATypeExpr<TerminalCreateParams> {
  return {value : {typeRef : {kind: "reference", value : snTerminalCreateParams}, parameters : []}};
}

export interface KeyModifiers {
  shift: boolean;
  ctrl: boolean;
  alt: boolean;
  capsLock: boolean;
}

export function makeKeyModifiers(
  input: {
    shift: boolean,
    ctrl: boolean,
    alt: boolean,
    capsLock: boolean,
  }
): KeyModifiers {
  return {
    shift: input.shift,
    ctrl: input.ctrl,
    alt: input.alt,
    capsLock: input.capsLock,
  };
}

const KeyModifiers_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"shift","default":{"kind":"nothing"},"name":"shift","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"ctrl","default":{"kind":"nothing"},"name":"ctrl","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"alt","default":{"kind":"nothing"},"name":"alt","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"capsLock","default":{"kind":"nothing"},"name":"capsLock","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"KeyModifiers","version":{"kind":"nothing"}}};

export const snKeyModifiers: ADL.ScopedName = {moduleName:"Terminal", name:"KeyModifiers"};

export function texprKeyModifiers(): ADL.ATypeExpr<KeyModifiers> {
  return {value : {typeRef : {kind: "reference", value : snKeyModifiers}, parameters : []}};
}

export enum SpecialKey {
  escape,
  f1,
  f2,
  f3,
  f4,
  f5,
  f6,
  f7,
  f8,
  f9,
  f10,
  f11,
  f12,
  insert,
  delete,
  home,
  end,
  pageUp,
  pageDown,
  tab,
  enter,
  backspace,
  arrowLeft,
  arrowRight,
  arrowUp,
  arrowDown,
}

const SpecialKey_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"escape","default":{"kind":"nothing"},"name":"escape","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"f1","default":{"kind":"nothing"},"name":"f1","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"f2","default":{"kind":"nothing"},"name":"f2","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"f3","default":{"kind":"nothing"},"name":"f3","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"f4","default":{"kind":"nothing"},"name":"f4","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"f5","default":{"kind":"nothing"},"name":"f5","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"f6","default":{"kind":"nothing"},"name":"f6","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"f7","default":{"kind":"nothing"},"name":"f7","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"f8","default":{"kind":"nothing"},"name":"f8","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"f9","default":{"kind":"nothing"},"name":"f9","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"f10","default":{"kind":"nothing"},"name":"f10","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"f11","default":{"kind":"nothing"},"name":"f11","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"f12","default":{"kind":"nothing"},"name":"f12","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"insert","default":{"kind":"nothing"},"name":"insert","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"delete","default":{"kind":"nothing"},"name":"delete","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"home","default":{"kind":"nothing"},"name":"home","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"end","default":{"kind":"nothing"},"name":"end","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"pageUp","default":{"kind":"nothing"},"name":"pageUp","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"pageDown","default":{"kind":"nothing"},"name":"pageDown","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"tab","default":{"kind":"nothing"},"name":"tab","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"enter","default":{"kind":"nothing"},"name":"enter","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"backspace","default":{"kind":"nothing"},"name":"backspace","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"arrowLeft","default":{"kind":"nothing"},"name":"arrowLeft","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"arrowRight","default":{"kind":"nothing"},"name":"arrowRight","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"arrowUp","default":{"kind":"nothing"},"name":"arrowUp","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"arrowDown","default":{"kind":"nothing"},"name":"arrowDown","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SpecialKey","version":{"kind":"nothing"}}};

export const snSpecialKey: ADL.ScopedName = {moduleName:"Terminal", name:"SpecialKey"};

export function texprSpecialKey(): ADL.ATypeExpr<SpecialKey> {
  return {value : {typeRef : {kind: "reference", value : snSpecialKey}, parameters : []}};
}

export interface KeyPress_SpecialKey {
  kind: 'specialKey';
  value: SpecialKey;
}
export interface KeyPress_Char {
  kind: 'char';
  value: string;
}

export type KeyPress = KeyPress_SpecialKey | KeyPress_Char;

export interface KeyPressOpts {
  specialKey: SpecialKey;
  char: string;
}

export function makeKeyPress<K extends keyof KeyPressOpts>(kind: K, value: KeyPressOpts[K]) { return {kind, value}; }

const KeyPress_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"specialKey","default":{"kind":"nothing"},"name":"specialKey","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"SpecialKey"}},"parameters":[]}},{"annotations":[],"serializedName":"char","default":{"kind":"nothing"},"name":"char","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"KeyPress","version":{"kind":"nothing"}}};

export const snKeyPress: ADL.ScopedName = {moduleName:"Terminal", name:"KeyPress"};

export function texprKeyPress(): ADL.ATypeExpr<KeyPress> {
  return {value : {typeRef : {kind: "reference", value : snKeyPress}, parameters : []}};
}

export interface KeyPressCommand {
  keyPress: KeyPress;
  keyModifiers: KeyModifiers;
}

export function makeKeyPressCommand(
  input: {
    keyPress: KeyPress,
    keyModifiers: KeyModifiers,
  }
): KeyPressCommand {
  return {
    keyPress: input.keyPress,
    keyModifiers: input.keyModifiers,
  };
}

const KeyPressCommand_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"keyPress","default":{"kind":"nothing"},"name":"keyPress","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"KeyPress"}},"parameters":[]}},{"annotations":[],"serializedName":"keyModifiers","default":{"kind":"nothing"},"name":"keyModifiers","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"KeyModifiers"}},"parameters":[]}}]}},"name":"KeyPressCommand","version":{"kind":"nothing"}}};

export const snKeyPressCommand: ADL.ScopedName = {moduleName:"Terminal", name:"KeyPressCommand"};

export function texprKeyPressCommand(): ADL.ATypeExpr<KeyPressCommand> {
  return {value : {typeRef : {kind: "reference", value : snKeyPressCommand}, parameters : []}};
}

export interface TerminalCommand_TerminalSize {
  kind: 'terminalSize';
  value: TerminalSize;
}
export interface TerminalCommand_KeyPressCommand {
  kind: 'keyPressCommand';
  value: KeyPressCommand;
}

export type TerminalCommand = TerminalCommand_TerminalSize | TerminalCommand_KeyPressCommand;

export interface TerminalCommandOpts {
  terminalSize: TerminalSize;
  keyPressCommand: KeyPressCommand;
}

export function makeTerminalCommand<K extends keyof TerminalCommandOpts>(kind: K, value: TerminalCommandOpts[K]) { return {kind, value}; }

const TerminalCommand_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"terminalSize","default":{"kind":"nothing"},"name":"terminalSize","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"TerminalSize"}},"parameters":[]}},{"annotations":[],"serializedName":"keyPressCommand","default":{"kind":"nothing"},"name":"keyPressCommand","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"KeyPressCommand"}},"parameters":[]}}]}},"name":"TerminalCommand","version":{"kind":"nothing"}}};

export const snTerminalCommand: ADL.ScopedName = {moduleName:"Terminal", name:"TerminalCommand"};

export function texprTerminalCommand(): ADL.ATypeExpr<TerminalCommand> {
  return {value : {typeRef : {kind: "reference", value : snTerminalCommand}, parameters : []}};
}

export interface TermLine {
  text: string;
  attrs: Uint8Array;
}

export function makeTermLine(
  input: {
    text: string,
    attrs: Uint8Array,
  }
): TermLine {
  return {
    text: input.text,
    attrs: input.attrs,
  };
}

const TermLine_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"text","default":{"kind":"nothing"},"name":"text","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"attrs","default":{"kind":"nothing"},"name":"attrs","typeExpr":{"typeRef":{"kind":"primitive","value":"Bytes"},"parameters":[]}}]}},"name":"TermLine","version":{"kind":"nothing"}}};

export const snTermLine: ADL.ScopedName = {moduleName:"Terminal", name:"TermLine"};

export function texprTermLine(): ADL.ATypeExpr<TermLine> {
  return {value : {typeRef : {kind: "reference", value : snTermLine}, parameters : []}};
}

export interface CursorPos {
  line: number;
  col: number;
}

export function makeCursorPos(
  input: {
    line: number,
    col: number,
  }
): CursorPos {
  return {
    line: input.line,
    col: input.col,
  };
}

const CursorPos_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"line","default":{"kind":"nothing"},"name":"line","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"col","default":{"kind":"nothing"},"name":"col","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"CursorPos","version":{"kind":"nothing"}}};

export const snCursorPos: ADL.ScopedName = {moduleName:"Terminal", name:"CursorPos"};

export function texprCursorPos(): ADL.ATypeExpr<CursorPos> {
  return {value : {typeRef : {kind: "reference", value : snCursorPos}, parameters : []}};
}

export interface TermSurface {
  screen: TermLine[];
  cursorPos: CursorPos;
  windowTitle: string;
  scrollBack: TermLine[];
  scrollBackVisible: boolean;
}

export function makeTermSurface(
  input: {
    screen: TermLine[],
    cursorPos: CursorPos,
    windowTitle: string,
    scrollBack: TermLine[],
    scrollBackVisible: boolean,
  }
): TermSurface {
  return {
    screen: input.screen,
    cursorPos: input.cursorPos,
    windowTitle: input.windowTitle,
    scrollBack: input.scrollBack,
    scrollBackVisible: input.scrollBackVisible,
  };
}

const TermSurface_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"screen","default":{"kind":"nothing"},"name":"screen","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"TermLine"}},"parameters":[]}]}},{"annotations":[],"serializedName":"cursorPos","default":{"kind":"nothing"},"name":"cursorPos","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"CursorPos"}},"parameters":[]}},{"annotations":[],"serializedName":"windowTitle","default":{"kind":"nothing"},"name":"windowTitle","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"scrollBack","default":{"kind":"nothing"},"name":"scrollBack","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"TermLine"}},"parameters":[]}]}},{"annotations":[],"serializedName":"scrollBackVisible","default":{"kind":"nothing"},"name":"scrollBackVisible","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"TermSurface","version":{"kind":"nothing"}}};

export const snTermSurface: ADL.ScopedName = {moduleName:"Terminal", name:"TermSurface"};

export function texprTermSurface(): ADL.ATypeExpr<TermSurface> {
  return {value : {typeRef : {kind: "reference", value : snTermSurface}, parameters : []}};
}

export interface TermSurfaceChange_SetWindowTitle {
  kind: 'setWindowTitle';
  value: SetWindowTitle;
}
export interface TermSurfaceChange_MoveCursor {
  kind: 'moveCursor';
  value: MoveCursor;
}
export interface TermSurfaceChange_UpdateLine {
  kind: 'updateLine';
  value: UpdateLine;
}
export interface TermSurfaceChange_AppendScrollBack {
  kind: 'appendScrollBack';
  value: AppendScrollBack;
}
export interface TermSurfaceChange_SetScrollBackVisible {
  kind: 'setScrollBackVisible';
  value: SetScrollBackVisible;
}
export interface TermSurfaceChange_ClearScrollBack {
  kind: 'clearScrollBack';
  value: ClearScrollBack;
}
export interface TermSurfaceChange_ClearScrollBackStart {
  kind: 'clearScrollBackStart';
  value: ClearScrollBackStart;
}
export interface TermSurfaceChange_ClearScrollBackEnd {
  kind: 'clearScrollBackEnd';
  value: ClearScrollBackEnd;
}
export interface TermSurfaceChange_Resize {
  kind: 'resize';
  value: Resize;
}

export type TermSurfaceChange = TermSurfaceChange_SetWindowTitle | TermSurfaceChange_MoveCursor | TermSurfaceChange_UpdateLine | TermSurfaceChange_AppendScrollBack | TermSurfaceChange_SetScrollBackVisible | TermSurfaceChange_ClearScrollBack | TermSurfaceChange_ClearScrollBackStart | TermSurfaceChange_ClearScrollBackEnd | TermSurfaceChange_Resize;

export interface TermSurfaceChangeOpts {
  setWindowTitle: SetWindowTitle;
  moveCursor: MoveCursor;
  updateLine: UpdateLine;
  appendScrollBack: AppendScrollBack;
  setScrollBackVisible: SetScrollBackVisible;
  clearScrollBack: ClearScrollBack;
  clearScrollBackStart: ClearScrollBackStart;
  clearScrollBackEnd: ClearScrollBackEnd;
  resize: Resize;
}

export function makeTermSurfaceChange<K extends keyof TermSurfaceChangeOpts>(kind: K, value: TermSurfaceChangeOpts[K]) { return {kind, value}; }

const TermSurfaceChange_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"setWindowTitle","default":{"kind":"nothing"},"name":"setWindowTitle","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"SetWindowTitle"}},"parameters":[]}},{"annotations":[],"serializedName":"moveCursor","default":{"kind":"nothing"},"name":"moveCursor","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"MoveCursor"}},"parameters":[]}},{"annotations":[],"serializedName":"updateLine","default":{"kind":"nothing"},"name":"updateLine","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"UpdateLine"}},"parameters":[]}},{"annotations":[],"serializedName":"appendScrollBack","default":{"kind":"nothing"},"name":"appendScrollBack","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"AppendScrollBack"}},"parameters":[]}},{"annotations":[],"serializedName":"setScrollBackVisible","default":{"kind":"nothing"},"name":"setScrollBackVisible","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"SetScrollBackVisible"}},"parameters":[]}},{"annotations":[],"serializedName":"clearScrollBack","default":{"kind":"nothing"},"name":"clearScrollBack","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"ClearScrollBack"}},"parameters":[]}},{"annotations":[],"serializedName":"clearScrollBackStart","default":{"kind":"nothing"},"name":"clearScrollBackStart","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"ClearScrollBackStart"}},"parameters":[]}},{"annotations":[],"serializedName":"clearScrollBackEnd","default":{"kind":"nothing"},"name":"clearScrollBackEnd","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"ClearScrollBackEnd"}},"parameters":[]}},{"annotations":[],"serializedName":"resize","default":{"kind":"nothing"},"name":"resize","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"Resize"}},"parameters":[]}}]}},"name":"TermSurfaceChange","version":{"kind":"nothing"}}};

export const snTermSurfaceChange: ADL.ScopedName = {moduleName:"Terminal", name:"TermSurfaceChange"};

export function texprTermSurfaceChange(): ADL.ATypeExpr<TermSurfaceChange> {
  return {value : {typeRef : {kind: "reference", value : snTermSurfaceChange}, parameters : []}};
}

export interface SetWindowTitle {
  title: string;
}

export function makeSetWindowTitle(
  input: {
    title: string,
  }
): SetWindowTitle {
  return {
    title: input.title,
  };
}

const SetWindowTitle_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"title","default":{"kind":"nothing"},"name":"title","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"SetWindowTitle","version":{"kind":"nothing"}}};

export const snSetWindowTitle: ADL.ScopedName = {moduleName:"Terminal", name:"SetWindowTitle"};

export function texprSetWindowTitle(): ADL.ATypeExpr<SetWindowTitle> {
  return {value : {typeRef : {kind: "reference", value : snSetWindowTitle}, parameters : []}};
}

export interface MoveCursor {
  cursorPos: CursorPos;
}

export function makeMoveCursor(
  input: {
    cursorPos: CursorPos,
  }
): MoveCursor {
  return {
    cursorPos: input.cursorPos,
  };
}

const MoveCursor_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"cursorPos","default":{"kind":"nothing"},"name":"cursorPos","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"CursorPos"}},"parameters":[]}}]}},"name":"MoveCursor","version":{"kind":"nothing"}}};

export const snMoveCursor: ADL.ScopedName = {moduleName:"Terminal", name:"MoveCursor"};

export function texprMoveCursor(): ADL.ATypeExpr<MoveCursor> {
  return {value : {typeRef : {kind: "reference", value : snMoveCursor}, parameters : []}};
}

export interface UpdateLine {
  line: number;
  termLine: TermLine;
}

export function makeUpdateLine(
  input: {
    line: number,
    termLine: TermLine,
  }
): UpdateLine {
  return {
    line: input.line,
    termLine: input.termLine,
  };
}

const UpdateLine_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"line","default":{"kind":"nothing"},"name":"line","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"termLine","default":{"kind":"nothing"},"name":"termLine","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"TermLine"}},"parameters":[]}}]}},"name":"UpdateLine","version":{"kind":"nothing"}}};

export const snUpdateLine: ADL.ScopedName = {moduleName:"Terminal", name:"UpdateLine"};

export function texprUpdateLine(): ADL.ATypeExpr<UpdateLine> {
  return {value : {typeRef : {kind: "reference", value : snUpdateLine}, parameters : []}};
}

export interface AppendScrollBack {
  termLine: TermLine;
}

export function makeAppendScrollBack(
  input: {
    termLine: TermLine,
  }
): AppendScrollBack {
  return {
    termLine: input.termLine,
  };
}

const AppendScrollBack_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"termLine","default":{"kind":"nothing"},"name":"termLine","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"TermLine"}},"parameters":[]}}]}},"name":"AppendScrollBack","version":{"kind":"nothing"}}};

export const snAppendScrollBack: ADL.ScopedName = {moduleName:"Terminal", name:"AppendScrollBack"};

export function texprAppendScrollBack(): ADL.ATypeExpr<AppendScrollBack> {
  return {value : {typeRef : {kind: "reference", value : snAppendScrollBack}, parameters : []}};
}

export interface SetScrollBackVisible {
  visible: boolean;
}

export function makeSetScrollBackVisible(
  input: {
    visible: boolean,
  }
): SetScrollBackVisible {
  return {
    visible: input.visible,
  };
}

const SetScrollBackVisible_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"visible","default":{"kind":"nothing"},"name":"visible","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"SetScrollBackVisible","version":{"kind":"nothing"}}};

export const snSetScrollBackVisible: ADL.ScopedName = {moduleName:"Terminal", name:"SetScrollBackVisible"};

export function texprSetScrollBackVisible(): ADL.ATypeExpr<SetScrollBackVisible> {
  return {value : {typeRef : {kind: "reference", value : snSetScrollBackVisible}, parameters : []}};
}

export interface ClearScrollBack {
}

export function makeClearScrollBack(
  _input: {
  }
): ClearScrollBack {
  return {
  };
}

const ClearScrollBack_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[]}},"name":"ClearScrollBack","version":{"kind":"nothing"}}};

export const snClearScrollBack: ADL.ScopedName = {moduleName:"Terminal", name:"ClearScrollBack"};

export function texprClearScrollBack(): ADL.ATypeExpr<ClearScrollBack> {
  return {value : {typeRef : {kind: "reference", value : snClearScrollBack}, parameters : []}};
}

export interface ClearScrollBackStart {
  numLines: number;
}

export function makeClearScrollBackStart(
  input: {
    numLines: number,
  }
): ClearScrollBackStart {
  return {
    numLines: input.numLines,
  };
}

const ClearScrollBackStart_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"numLines","default":{"kind":"nothing"},"name":"numLines","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"ClearScrollBackStart","version":{"kind":"nothing"}}};

export const snClearScrollBackStart: ADL.ScopedName = {moduleName:"Terminal", name:"ClearScrollBackStart"};

export function texprClearScrollBackStart(): ADL.ATypeExpr<ClearScrollBackStart> {
  return {value : {typeRef : {kind: "reference", value : snClearScrollBackStart}, parameters : []}};
}

export interface ClearScrollBackEnd {
  numLines: number;
}

export function makeClearScrollBackEnd(
  input: {
    numLines: number,
  }
): ClearScrollBackEnd {
  return {
    numLines: input.numLines,
  };
}

const ClearScrollBackEnd_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"numLines","default":{"kind":"nothing"},"name":"numLines","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"ClearScrollBackEnd","version":{"kind":"nothing"}}};

export const snClearScrollBackEnd: ADL.ScopedName = {moduleName:"Terminal", name:"ClearScrollBackEnd"};

export function texprClearScrollBackEnd(): ADL.ATypeExpr<ClearScrollBackEnd> {
  return {value : {typeRef : {kind: "reference", value : snClearScrollBackEnd}, parameters : []}};
}

export interface Resize {
  size: TerminalSize;
}

export function makeResize(
  input: {
    size: TerminalSize,
  }
): Resize {
  return {
    size: input.size,
  };
}

const Resize_AST : ADL.ScopedDecl =
  {"moduleName":"Terminal","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"size","default":{"kind":"nothing"},"name":"size","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"TerminalSize"}},"parameters":[]}}]}},"name":"Resize","version":{"kind":"nothing"}}};

export const snResize: ADL.ScopedName = {moduleName:"Terminal", name:"Resize"};

export function texprResize(): ADL.ATypeExpr<Resize> {
  return {value : {typeRef : {kind: "reference", value : snResize}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "Terminal.TerminalSize" : TerminalSize_AST,
  "Terminal.TerminalCreateParams" : TerminalCreateParams_AST,
  "Terminal.KeyModifiers" : KeyModifiers_AST,
  "Terminal.SpecialKey" : SpecialKey_AST,
  "Terminal.KeyPress" : KeyPress_AST,
  "Terminal.KeyPressCommand" : KeyPressCommand_AST,
  "Terminal.TerminalCommand" : TerminalCommand_AST,
  "Terminal.TermLine" : TermLine_AST,
  "Terminal.CursorPos" : CursorPos_AST,
  "Terminal.TermSurface" : TermSurface_AST,
  "Terminal.TermSurfaceChange" : TermSurfaceChange_AST,
  "Terminal.SetWindowTitle" : SetWindowTitle_AST,
  "Terminal.MoveCursor" : MoveCursor_AST,
  "Terminal.UpdateLine" : UpdateLine_AST,
  "Terminal.AppendScrollBack" : AppendScrollBack_AST,
  "Terminal.SetScrollBackVisible" : SetScrollBackVisible_AST,
  "Terminal.ClearScrollBack" : ClearScrollBack_AST,
  "Terminal.ClearScrollBackStart" : ClearScrollBackStart_AST,
  "Terminal.ClearScrollBackEnd" : ClearScrollBackEnd_AST,
  "Terminal.Resize" : Resize_AST
};
